import MapPlan from "@/helpers/maps/MapPlan.js";

export default {
    namespaced: true,
    state: () => ({
        map: null,
        floor: null,
        debug: {
            enabled: false,
            pano: false,
            map: false,
            links: false,
            // debug the current path
            path: false,
            // debug the pathfinding instance and cost
            pathfinder: false,
            svg: false,
            menuVisible: false,
            freeNavigation: false,
            emulateGPS: false,
            noisyGPS: false,
            pedometerWithoutGps: false,
            disableOrientation: false,
            showArPanoGridInLive: false,
            orientation: {
                enabled: false,
                alpha: 0,
                targetAlpha: null,
                angleDeadZone: 0.18,
                isHolding: false,
                smoothingRaf: null,
                maxTurnSpeedDegPerSec: 540
            }
        },
        navSettings: {
            static: true,
            compass: false,
            gps: false,
            image360: false,
            pedometer: false,
            // preferences are used by the pathfinder
            preferences: {
                accessible: true
            }
        },
        width: 1920,
        height: 1080,
        startId: null,
        endId: null,
        latestStartId: null,
        latestEndId: null,
        isCurrentLocationOnSite: null
    }),
    actions: {},
    mutations: {
        setMap(state, map) {
            state.map = new MapPlan(map);
        },
        setFloor(state, floor) {
            state.floor = floor;
        },
        setStartId(state, id) {
            state.startId = id || null;
        },
        setEndId(state, id) {
            state.endId = id || null;
        },
        setLatestStartId(state, id) {
            state.latestStartId = id || null;
        },
        setLatestEndId(state, id) {
            state.latestEndId = id || null;
        },
        clearEndpoints(state) {
            state.startId = null;
            state.endId = null;
        },
        clearAllEndpoints(state) {
            state.startId = null;
            state.endId = null;
            state.latestStartId = null;
            state.latestEndId = null;
        },
        setIsCurrentLocationOnSite(state, value) {
            if (value === null) {
                state.isCurrentLocationOnSite = null;
                return;
            }
            state.isCurrentLocationOnSite = !!value;
        }
    }
}
